
import { FileDown, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ResourceDownloader } from "@/services/downloads/ResourceDownloader";
import { useState } from "react";
import { toast } from "sonner";

interface DownloadButtonProps {
  resourceId: string;
  topic?: string;
  company?: string;
  isMobile?: boolean;
}

export function DownloadButton({ resourceId, topic = "Training", company = "Company", isMobile = false }: DownloadButtonProps) {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    if (isDownloading) return;

    try {
      setIsDownloading(true);
      toast.info("Preparing download package...");
      
      // Add debug log for the resource ID
      console.log(`Starting download for resource: ${resourceId}, topic: ${topic}, company: ${company}`);
      
      await ResourceDownloader.downloadContentZip(resourceId, topic, company);
    } catch (error) {
      console.error("Error downloading training files:", error);
      toast.error("Failed to download training files. Please try again.");
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="p-4 border-t border-muted">
      <Button
        onClick={handleDownload}
        variant="outline"
        className="w-full"
        size={isMobile ? "sm" : "default"}
        disabled={isDownloading}
      >
        {isDownloading ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Preparing Files...
          </>
        ) : (
          <>
            <FileDown className="mr-2 h-4 w-4" />
            Download Training Files
          </>
        )}
      </Button>
    </div>
  );
}
